(function () {
  'use strict';

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-orevielle-buy-now]');
    if (!button || button.disabled) return;

    event.preventDefault();

    var form =
      button.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var variantInput = form.querySelector('[name="id"]');
    if (!variantInput || !variantInput.value) return;

    var quantityInput = form.querySelector('[name="quantity"]');
    var originalText = button.textContent;
    var root =
      (window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      '/';

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Wird vorbereitet...';

    try {
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantInput.value),
          quantity: quantityInput ? Number(quantityInput.value || 1) : 1
        })
      });

      if (!response.ok) throw new Error('Unable to add item');
      window.location.assign(root + 'checkout');
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = originalText;
      window.alert(
        'Bitte versuchen Sie es erneut oder legen Sie den Artikel zuerst in den Warenkorb.'
      );
    }
  });
})();
